<div class="w-full display flex flex-col gap-6">
  <div class="flex justify-between py-6 border-b border-neutral-base">
    <span class="text-[18px] font-black">
      <i
        [class.pi]="true"
        [class.pi-file-check]="true"
        style="font-size: 2rem"></i>
      REVISIÓN DE INFORME GENERADO
    </span>

    <div class="flex gap-3">
      <app-buttons
        [label]="'Cancelar'"
        (click)="goBackToProjectsList()" />

      @if (pdfUrl()) {
        <app-buttons
          [label]="'Enviar informe'"
          [classes]="'bg-primary-base text-white'"
          [disabled]="!canSend()"
          (click)="sendReport()" />
      }
    </div>
  </div>

  @if (hasError()) {
    <section class="flex flex-col gap-2 border border-alert-base p-6">
      <span class="text-xl font-bold">No se pudo cargar el documento</span>
      <span class="text-[16px] text-neutral-dark">Inténtalo de nuevo más tarde.</span>
    </section>
  } @else {
    @if (pdfUrl(); as pdfSrc) {
      <div class="text-[16px] mt-2">
        Revisa el documento antes de enviarlo. Una vez enviado, continuará el proceso de aprobación.
      </div>

      <section class="card">
        <div class="flex items-center justify-between -mt-2">
          <!-- <div class="text-xl font-bold">Estado del documento</div> -->
        </div>

        <div class="mt-4 border border-neutral-base rounded p-3">
          <div class="flex items-start justify-between gap-3">
            <div class="text-md text-neutral-dark">Documento generado</div>

            <div class="flex items-center gap-2">
              <div class="w-4 h-4 rounded-sm bg-success-base"></div>
              <div class="text-md">Generado correctamente</div>
            </div>
          </div>

          <div class="mt-2 text-[16px]">
            El documento
            <span class="font-bold">"{{ reportContext()?.nombreProyecto }}"</span>
            está listo para su revisión y envío.
          </div>
        </div>
      </section>

      <section class="flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <span class="text-xl font-bold">Visor PDF</span>
        </div>

        <div class="report-viewer__pdf border border-neutral-base rounded">
          <div class="report-viewer__pdf-canvas">
            <ng-template #reportViewerToolbar>
              <div class="report-viewer__toolbar">
                <div class="report-viewer__toolbar-section report-viewer__toolbar-section--left">
                  <pdf-toggle-sidebar [show]="'always-visible'" />
                </div>

                <div class="report-viewer__toolbar-section report-viewer__toolbar-section--center">
                  <pdf-paging-area
                    [showPagingButtons]="'always-visible'"
                    [showFirstAndLastPageButtons]="'always-visible'"
                    [showPreviousAndNextPageButtons]="'always-visible'"
                    [showPageNumber]="'always-visible'"
                    [showPageLabel]="false" />
                </div>

                <div class="report-viewer__toolbar-section report-viewer__toolbar-section--right">
                  <pdf-zoom-out [showZoomButtons]="'always-visible'" />
                  <pdf-zoom-in [showZoomButtons]="'always-visible'" />
                </div>
              </div>
            </ng-template>

            <ngx-extended-pdf-viewer
              [src]="pdfSrc"
              [customToolbar]="reportViewerToolbar"
              height="100%"
              [textLayer]="true"
              [showToolbar]="true"
              [showBorders]="false"
              [supportsDownloading]="false"
              [showSidebarButton]="'always-visible'"
              [activeSidebarView]="thumbnailSidebarView"
              [showFindButton]="false"
              [showOpenFileButton]="false"
              [showPrintButton]="false"
              [showDownloadButton]="false"
              [showSecondaryToolbarButton]="false"
              [showPresentationModeButton]="false"
              [showRotateButton]="false"
              [showHandToolButton]="false"
              [showSpreadButton]="false"
              [showPropertiesButton]="false"
              [showScrollingButtons]="false"
              [showSinglePageModeButton]="false"
              [showVerticalScrollButton]="false"
              [showHorizontalScrollButton]="false"
              [showWrappedScrollButton]="false"
              [showInfiniteScrollButton]="false"
              [showBookModeButton]="false"
              [showPageFlipButton]="false"
              [showMovePageButton]="false"
              [showPagingButtons]="'always-visible'"
              [showFirstAndLastPageButtons]="'always-visible'"
              [showPreviousAndNextPageButtons]="'always-visible'"
              [showPageNumber]="'always-visible'"
              [showPageLabel]="false"
              [showZoomButtons]="'always-visible'"
              [showZoomDropdown]="false"
              [showEditorButtons]="false"
              [showTextEditor]="false"
              [showStampEditor]="false"
              [showCommentEditor]="false"
              [showDrawEditor]="false"
              [showHighlightEditor]="false"
              [showSignatureEditor]="false"></ngx-extended-pdf-viewer>
          </div>
        </div>
      </section>
    }
  }
</div>
<p-confirmdialog />
